import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const cases_comorbidity:SchemaTableOptions = {
    name:<string> 'cases_comorbidity',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'cases_id', value: 'INTEGER UNSIGNED'},
        { column: 'comorbidity_id', value: 'INTEGER UNSIGNED'},
    ]
}